/**
 * What every event-log binding reads off a page: the newest row, for the coverage engine's progress.
 */

/**
 * The newest `createdAt` among `rows`, in whatever order they came; undefined for no rows.
 *
 * A delta page comes oldest first, but a binding that merges pages, or a route that orders on another axis, cannot
 * rely on the last row being the newest, so every row is read. A row that states no `createdAt` is skipped.
 */
export function newestCreatedAtOf<T extends { createdAt?: string | null }>(rows: readonly T[]): Date | undefined {
  let newest: number | undefined;
  for (const row of rows) {
    if (row.createdAt == null) continue;
    const created = Date.parse(row.createdAt);
    if (Number.isNaN(created)) continue;
    if (newest === undefined || created > newest) newest = created;
  }
  return newest === undefined ? undefined : new Date(newest);
}
